export function loadScript(id, src) {
  return new Promise((resolve, reject) => {
    if (document.getElementById(id)) {
      resolve(0)
      return
    }
    const script = document.createElement('script')
    script.id = id
    script.src = src
    script.async = false // Ensure synchronous execution
    script.onload = () => {
      resolve(1)
    }
    script.onerror = () => {
      reject(new Error(`Failed to load script: ${src}`))
    }
    document.head.appendChild(script)
  })
}
